<div class="grid w-full grid-cols-1 min-h-0 gap-6 items-center justify-center">
  <div class="flex flex-row justify-between pb-3">
    <div class="flex flex-col">
      <h3 class="text-base/7 font-semibold text-gray-900">Profielgegevens</h3>
      <p class="text-sm/6 text-gray-500">Persoonlijke en dienstverbandinformatie.</p>
    </div>
    @if (showEditButton()) {
      <button type="button"
              class="btn-secondary-flat hover-effect-elevate transition-expand"
              (click)="toggleEditing()">
        Bewerken
      </button>
    } @else if (showSaveActions()) {
      <div class="flex items-center gap-4 justify-end">
        <button type="button"
                (click)="toggleEditing()"
                class="btn-secondary-flat hover-effect-elevate transition-expand">
          Annuleren
        </button>
        <lib-button [button]="profileManagementButton"
                    (click)="handleSaveEvent()"></lib-button>
      </div>
    }
  </div>

  @if (!isReadonly()) {
    <lib-input-wrapper [inputSchema]="profileManagementSchema"
                       [parentFormGroup]="formGroup()">
      @if (canEditDepartment()) {
        <app-search-objects [defaultObjects]="departments()"
                            [selected]="selectedDepartments()"
                            [debounceMs]="300"
                            [objects]="searchDepartments()"
                            (queryChange)="handleDepartmentQueryChange($event)"
                            (selectionChange)="handleDepartmentSelection($event)"
                            [formGroup]="formGroup()"
                            [controlKey]="'department'"
                            [name]="'Afdeling'"
                            [emptyMessage]="'Geen afdelingen beschikbaar. Maak eerst een afdeling aan.'"
                            [multiple]="true"
                            [compareBy]="'id'"></app-search-objects>
      }
      <app-search-objects [defaultObjects]="availableCoaches()"
                          [selected]="selectedCoach()"
                          [debounceMs]="300"
                          [objects]="searchedCoaches()"
                          (queryChange)="searchCoaches($event)"
                          (selectionChange)="handleCoachSelection($event)"
                          [formGroup]="formGroup()"
                          [controlKey]="'coach'"
                          [name]="'Coach'"
                          [readOnly]="!canEditCareerProfile()"
                          [multiple]="false"
                          [compareBy]="'id'"></app-search-objects>
      <div class="flex flex-col gap-1">
        <label class="block text-sm font-medium text-gray-700">Manager</label>
        <input type="text"
               [value]="selectedManager()?.name || 'Geen manager gekoppeld'"
               disabled
               class="block w-full rounded-md border border-gray-300 bg-gray-200 px-3 py-2 text-sm text-neutral-grey-950 cursor-not-allowed" />
      </div>
      <app-search-objects [defaultObjects]="availablePopPmManagers()"
                          [selected]="selectedPopPmManager()"
                          [debounceMs]="300"
                          [objects]="searchedPopPmManagers()"
                          (queryChange)="searchPopPmManagers($event)"
                          (selectionChange)="handlePopPmManagerSelection($event)"
                          [formGroup]="formGroup()"
                          [controlKey]="'popPmManager'"
                          [name]="'POP/PM manager'"
                          [compareBy]="'id'"
      ></app-search-objects>
      <app-search-objects [defaultObjects]="availableManagers()"
                          [selected]="selectedManager()"
                          [debounceMs]="300"
                          [objects]="searchedManagers()"
                          (queryChange)="searchManagers($event)"
                          (selectionChange)="selectedManager.set($event)"
                          [formGroup]="formGroup()"
                          [controlKey]="'manager'"
                          [name]="'Manager'"
                          [emptyMessage]="'Geen gebruikers met managerrol beschikbaar.'"
                          [readOnly]="!canEditCareerProfile()"
                          [multiple]="false"
                          [compareBy]="'id'"></app-search-objects>
      <app-search-objects [defaultObjects]="defaultCareerTargets()"
                          [selected]="selectedCareerTarget()"
                          [debounceMs]="300"
                          [objects]="careerTargets()"
                          (queryChange)="handleQueryChange($event, 'careerTarget')"
                          [formGroup]="formGroup()"
                          [controlKey]="'careerProfile'"
                          [name]="'Doelfunctieprofiel voor Ontwikkelplan*'"
                          [readOnly]="!canEditCareerProfile()"
                          [multiple]="false"
                          [compareBy]="'id'"></app-search-objects>
      <app-search-objects [defaultObjects]="defaultCareerFunctions()"
                          [selected]="selectedCareerFunction()"
                          [debounceMs]="300"
                          [objects]="searchCareerFunctions()"
                          (queryChange)="handleQueryChange($event, 'careerFunction')"
                          [formGroup]="formGroup()"
                          [controlKey]="'functionName'"
                          [name]="'Huidige functie voor PM*'"
                          [readOnly]="!canEditCareerProfile()"
                          [multiple]="false"
                          [compareBy]="'id'"></app-search-objects>
      <app-profile-document-options [selected]="coursesAndTrainings()"
                                [parentFormGroup]="formGroup()"
                                [name]="'Cursussen en opleidingen'"
                                [userId]="selectedProfile()?.user?.id ?? ''"
                                [documentType]="DocumentType.COURSES_AND_TRAININGS"></app-profile-document-options>
      <app-profile-document-options [selected]="diplomas()"
                                [parentFormGroup]="formGroup()"
                                [name]="'Diploma\'s'"
                                [userId]="selectedProfile()?.user?.id ?? ''"
                                [documentType]="DocumentType.DIPLOMA"></app-profile-document-options>
      <app-profile-document-options [selected]="certificates()"
                                [parentFormGroup]="formGroup()"
                                [name]="'Certificaten'"
                                [userId]="selectedProfile()?.user?.id ?? ''"
                                [documentType]="DocumentType.CERTIFICATE"></app-profile-document-options>
    </lib-input-wrapper>
  } @else {
    <dl class="divide-y divide-neutral-grey-200">
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Medewerkernummer</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          {{ selectedProfile()?.employeeNr }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Geboortedatum</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">{{
            selectedProfile()?.birthDate |
              date:'dd-MM-yyyy'
          }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Contact</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          {{ selectedProfile()?.user?.email }}<br/>
          {{ selectedProfile()?.phoneNumber }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Afdeling</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          <div class="flex flex-col gap-1">
            @for (department of departmentDisplayItems(); track department.id) {
              <span>{{ department.name }}</span>
            } @empty {
              <span>Onbekend</span>
            }
          </div>
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Team / kostenplaats</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          {{ selectedProfile()?.team || 'Onbekend' }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Dienstverband</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          <div class="space-y-2">
            <div class="flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-3">
              <span class="text-sm text-neutral-grey-700 sm:min-w-28">In dienst sinds</span>
              <span class="text-sm text-neutral-grey-950">
                {{
                  selectedProfile()?.employmentDate |
                    date:'dd-MM-yyyy'
                }}
              </span>
            </div>
            @if (selectedProfile()?.employmentEndDate) {
              <div class="flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-3">
                <span class="text-sm text-neutral-grey-700 sm:min-w-28">Uit dienst</span>
                <span class="text-sm text-neutral-grey-950">
                {{ selectedProfile()?.employmentEndDate | date:'dd-MM-yyyy' }}
              </span>
              </div>
            }
          </div>
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Type dienstverband</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          {{ selectedProfile()?.employmentType | employmentType }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Type instroom</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          {{ selectedProfile()?.inflowType | inflowType }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Status</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          {{ selectedProfile()?.status | status }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Aantal contracturen per week</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          {{ selectedProfile()?.contractHours ?? 'Onbekend' }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Aantal/hoeveelheid FTE</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          {{ selectedProfile()?.fte ?? 'Onbekend' }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Salaris</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          <div class="space-y-2">
            <div class="flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-3">
              <span class="text-sm text-neutral-grey-700 sm:min-w-28">CAO Schaal</span>
              <span class="text-sm text-neutral-grey-950">
                {{ selectedProfile()?.jobScale }}
              </span>
            </div>
            <div class="flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-3">
              <span class="text-sm text-neutral-grey-700 sm:min-w-28">Type salaris</span>
              <span class="text-sm text-neutral-grey-950">
                {{ selectedProfile()?.salaryType | salaryType }}
              </span>
            </div>
          </div>
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Hoogst genoten opleiding</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          {{
            selectedProfile()?.highestEducation
          }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">LinkedIn profiel</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          {{ selectedProfile()?.linkedInUrl || 'Geen' }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Mijnskillspaspoort</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          -
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Manager</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          {{ selectedManager()?.name || 'Geen manager gekoppeld' }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Coach</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          {{ selectedCoach()?.name || 'Geen coach gekoppeld' }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">POP/PM manager</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          {{ selectedPopPmManager()?.name || 'Geen POP/PM manager gekoppeld' }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Doelfunctieprofiel voor Ontwikkelplan</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          {{ selectedCareerTarget()?.name || 'Geen doelfunctieprofiel gekoppeld' }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Bedrijfseigen functie voor Prestatie-afspraak</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">{{
            selectedCareerFunction()?.name ||
            'Onbekend'
          }}
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Cursussen en opleidingen</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          @let cursussen = getDocumentsByType(selectedProfile()?.documents, DocumentType.COURSES_AND_TRAININGS);
          @if (cursussen.length === 0) { Geen }
          <div class="divide-y divide-neutral-grey-200">
            @for (doc of cursussen; track doc.id) {
              <ng-container *ngTemplateOutlet="documentCard; context: { $implicit: doc }"></ng-container>
            }
          </div>
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Diploma's</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          @let diplomas = getDocumentsByType(selectedProfile()?.documents, DocumentType.DIPLOMA);
          @if (diplomas.length === 0) { Geen }
          <div class="divide-y divide-neutral-grey-200">
            @for (doc of diplomas; track doc.id) {
              <ng-container *ngTemplateOutlet="documentCard; context: { $implicit: doc }"></ng-container>
            }
          </div>
        </dd>
      </div>
      <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-neutral-grey-700">Certificaten</dt>
        <dd class="mt-1 text-sm text-neutral-grey-950 sm:col-span-2 sm:mt-0">
          @let certificaten = getDocumentsByType(selectedProfile()?.documents, DocumentType.CERTIFICATE);
          @if (certificaten.length === 0) { Geen }
          <div class="divide-y divide-neutral-grey-200">
            @for (doc of certificaten; track doc.id) {
              <ng-container *ngTemplateOutlet="documentCard; context: { $implicit: doc }"></ng-container>
            }
          </div>
        </dd>
      </div>

      <ng-template #documentCard let-doc>
        <div class="py-3">
          <p class="font-semibold text-sm text-gray-900 mb-3">{{ doc.name }}</p>
          <div class="grid grid-cols-3 gap-4 mb-3">
            <div>
              <p class="text-xs font-medium text-gray-500 uppercase tracking-wide">Niveau</p>
              <p class="text-sm text-gray-900 mt-1">{{ getDocumentLevelLabel(doc.level) }}</p>
            </div>
            <div>
              <p class="text-xs font-medium text-gray-500 uppercase tracking-wide">Behaald op</p>
              <p class="text-sm text-gray-900 mt-1">{{ doc.achievementDate | date:'dd-MM-yyyy' }}</p>
            </div>
            <div>
              <p class="text-xs font-medium text-gray-500 uppercase tracking-wide">Geldig tot</p>
              <p class="text-sm text-gray-900 mt-1">{{ doc.expirationDate | date:'dd-MM-yyyy' }}</p>
            </div>
          </div>
          @if (doc.id) {
            <div class="flex items-center justify-between rounded border border-gray-200 px-3 py-2">
              <div>
                <p class="text-sm text-gray-900">{{ doc.name }}</p>
                <p class="text-xs text-gray-500">Certificaatbestand</p>
              </div>
              <button type="button"
                      (click)="openDocument(doc)"
                      class="text-sm font-medium text-blue-600 hover:text-blue-800">
                Open
              </button>
            </div>
          }
        </div>
      </ng-template>
    </dl>
  }
</div>
